<template>
  <div class="props-group">
      <div class="private">
        <el-form-item label="自定义后缀" v-if="component.componentType!=='rc-currency'">
          <el-input v-model="component.properties.customSuffix" maxlength='10'/>
        </el-form-item>
        <el-form-item label="数字类型">
          <el-select v-model="component.properties.numType" placeholder="请选择">
            <el-option label="整数" value="num"></el-option>
            <el-option label="小数" value="decimal"></el-option>
            <el-option  v-if="component.componentType!=='rc-currency'" label="百分比" value="percentage"></el-option>
            <el-option  v-if="component.componentType!=='rc-currency'" label="年" value="year"></el-option>
            <el-option  v-if="component.componentType!=='rc-currency'" label="月" value="month"></el-option>
            <el-option  v-if="component.componentType!=='rc-currency'" label="天" value="day"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="小数位数" v-if="component.properties.numType==='decimal'">
          <el-input v-model="component.properties.decimal" @input="changedataType"/>
        </el-form-item>
      </div>
  </div>
</template>

<script>
export default {
  name: 'attr-postfix',
  props: ['component'],
  methods: {
    changedataType (val) {

    }
  },
  watch: {
    'component.properties.numType' (val) {
      if (val === 'num') {
        this.component.archive.dataType = 'decimal0'
      } else if (this.component.properties.numType === 'decimal') {
        this.component.properties.decimal = '2'
        this.component.archive.dataType = 'decimal2'
      } else {
        this.component.archive.dataType = 'decimal'
      }
    },
    'component.properties.decimal' (val) {
      switch (val) {
        case '1':
          this.component.archive.dataType = 'decimal1'
          break
        case '2':
          this.component.archive.dataType = 'decimal2'
          break
        case '3':
          this.component.archive.dataType = 'decimal3'
          break
        case '4':
          this.component.archive.dataType = 'decimal4'
          break
        case '5':
          this.component.archive.dataType = 'decimal5'
          break
        default:
          this.component.archive.dataType = 'decimal'
      }
    }
  }
}
</script>

<style lang="scss">
  .private {
    border-top: 1px solid #c2c3c4;
    margin: 0 -20px;
    padding: 0 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/postfix.vue